module.exports = __webpack_public_path__ + "media/images/iconSocialShare__errorRed-f6b92c74fbd6b20a30c8001c9baf64c6.png";